export default {
      id: "save_as_template-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#save_as_template",
      toString: function () {
        return this.url;
      }
    }